var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"protocol"},[_c('div',{staticClass:"protocol-font"},[_vm._v(_vm._s(_vm.protocol.title))]),_c('div',{staticClass:"protocol-content"},[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.protocol.content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }